import { MouseEventHandler, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from '../../app/store';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import { writeChecklist } from './checklistSlice';
import EditChecklist from './EditChecklist';
import { ChecklistUpdate } from './types';

const RouteChecklistCreate = () => {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const checklistStatus = useSelector((state: RootState) => state.checklist.status)
  const checklistError = useSelector((state: RootState) => state.checklist.error)
  const [checklistState, setChecklistState] = useState<ChecklistUpdate>({ name: "" });

  const onSaveClicked: MouseEventHandler<HTMLButtonElement> = async (evt) => {
    if (auth.authToken) {
      const result = await dispatch(writeChecklist({
        authToken: auth.authToken,
        checklist: checklistState,
      })).unwrap();
      navigate(`/checklist/${result?.checklist.id}/edit`)
    } else {
      console.log('No auth token!');
    }
  }

  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to="/checklists">
            <Button variant='secondary'>Cancel</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          {checklistStatus === 'loading' && <LoadingIndicator />}
          {checklistError && <div>{checklistError}</div>}
          <EditChecklist checklistState={checklistState} setChecklistState={setChecklistState}>
            <Row>
              <Col className="col-sm-auto">
                <button type="button" className="btn btn-primary" onClick={onSaveClicked} disabled={checklistStatus === 'loading'}>
                  Create checklist
                </button>
              </Col>
              <Col className="col-sm-auto ml-auto">
              </Col>
            </Row>
          </EditChecklist>
        </Col>
      </Row>
    </>
  );
};

export default RouteChecklistCreate;
